import React from "react";
import "./styles/Invoice.css";

export default function InvoiceFilters({
  searchText,
  setSearchText,

  filterCategory,
  setFilterCategory,

  filterMonth,
  setFilterMonth,

  filterYear,
  setFilterYear,

  addRow
}) {

  const years = [];

  for (let y = 2015; y <= 2026; y++) {
    years.push(y);
  }

  return (
    <div className="top-bar">

      <div className="filters">

        <input
          placeholder="Search Customer / Description"
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
        />

        <select
          value={filterCategory}
          onChange={e => setFilterCategory(e.target.value)}
        >
          <option value="">All</option>
          <option>Travel</option>
          <option>Hotel</option>
          <option>Shopping</option>
          <option>Billing</option>
          <option>Others</option>
        </select>

        {/* MONTH FILTER */}

        <select
          value={filterMonth}
          onChange={e => setFilterMonth(e.target.value)}
        >
          <option value="">All Months</option>

          <option value="01">Jan</option>
          <option value="02">Feb</option>
          <option value="03">Mar</option>
          <option value="04">Apr</option>
          <option value="05">May</option>
          <option value="06">Jun</option>
          <option value="07">Jul</option>
          <option value="08">Aug</option>
          <option value="09">Sep</option>
          <option value="10">Oct</option>
          <option value="11">Nov</option>
          <option value="12">Dec</option>
        </select>

        {/* YEAR FILTER */}

        <select
          value={filterYear}
          onChange={e => setFilterYear(e.target.value)}
        >
          <option value="">All Years</option>

          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>

      </div>

      <button
        className="add-btn"
        onClick={addRow}
      >
        Add Expense
      </button>

    </div>
  );
}